import { useEffect, useState } from "react";
import { Modal, Descriptions, Empty, Spin, Tag, Typography } from "antd";
import { t } from "i18next";
import moment from "moment";
import ApiService from "../../core/service/ApiService";

const { Text } = Typography;

const fmt = (d) => d ? moment(d).format('DD.MM.YYYY HH:mm:ss') : '-'

export default function EnabizTeletipStatusModal({ appointmentId, accessionNumber, lastCheckDate, open, onClose }) {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);

    useEffect(() => {
        if (!open || !appointmentId) {
            setList([]);
            return;
        }
        setLoading(true);
        ApiService.AppointmentTeletip.GetTeletipOrderStatus(appointmentId).then(res => {
            if (res.success) {
                const data = res.data || [];
                setList(accessionNumber ? data.filter(x => x.accessionNumber === accessionNumber) : data);
            }
        }).finally(() => setLoading(false));
    }, [open, appointmentId, accessionNumber])

    return (
        <Modal
            title={t('Teletip Order Status')}
            open={open}
            onCancel={onClose}
            footer={null}
            width={900}
        >
            {/* Bu ekran ANLIK bakıştır, sonucu kaydetmez. Kaydedilmiş takip verisi grid'deki
                "Görüntü Eşleşme" kolonundadır; ikisi arasındaki farkı görebilmek için son
                kayıtlı sorgunun zamanı burada gösterilir. */}
            <div style={{ marginBottom: 12 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    {t('Live query — not saved.')} {t('Last saved query')}: {fmt(lastCheckDate)}
                </Text>
            </div>
            {loading ? (
                <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
            ) : list.length === 0 ? (
                <Empty description={t('No status found')} />
            ) : (
                list.map((status, i) => (
                    <div key={i} style={{ marginBottom: 18, paddingBottom: 12, borderBottom: i < list.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                        <Descriptions title={`Accession: ${status.accessionNumber}`} bordered size="small" column={2}>
                            <Descriptions.Item label={t('TCKN')}>{status.citizenId || '-'}</Descriptions.Item>
                            <Descriptions.Item label={t('SUT Code')}>{status.sutCode || '-'}</Descriptions.Item>
                            <Descriptions.Item label={t('Teletip Status')}>
                                <Tag color={status.teletipStatusId === 1 ? 'success' : status.teletipStatusId === 2 ? 'processing' : 'default'}>
                                    {status.teletipStatus || '-'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Medula Status')}>
                                <Tag color={status.medulaStatusId === 1 ? 'success' : status.medulaStatusId === 2 ? 'warning' : 'default'}>
                                    {status.medulaStatus || '-'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label={t('WADO Status')}>
                                <Tag color={status.wadoStatusId === 1 ? 'success' : status.wadoStatusId === 2 ? 'processing' : status.wadoStatusId === 3 ? 'warning' : 'default'}>
                                    {status.wadoStatus || '-'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Report Status')}>
                                <Tag color={status.reportStatusId === 1 ? 'success' : status.reportStatusId === 2 ? 'warning' : 'default'}>
                                    {status.reportStatus || '-'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Dose Status')}>
                                <Tag color={status.doseStatusId === 1 ? 'success' : status.doseStatusId === 2 ? 'warning' : 'default'}>
                                    {status.doseStatus || '-'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Duplicate Check')}>
                                {status.patientHistorySearchStatus || '-'}
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Request Date')}>{fmt(status.requestDate)}</Descriptions.Item>
                            <Descriptions.Item label={t('Schedule Date')}>{fmt(status.scheduleDate)}</Descriptions.Item>
                            <Descriptions.Item label={t('Performed Date')}>{fmt(status.performedDate)}</Descriptions.Item>
                            <Descriptions.Item label={t('Reported Date')}>{fmt(status.reportedDate)}</Descriptions.Item>
                            <Descriptions.Item label={t('Last Medula Send')}>{fmt(status.lastMedulaSendDate)}</Descriptions.Item>
                            <Descriptions.Item label={t('Medula Response Code')}>{status.medulaResponseCode || '-'}</Descriptions.Item>
                            {status.medulaResponseMessage && (
                                <Descriptions.Item label={t('Medula Message')} span={2}>{status.medulaResponseMessage}</Descriptions.Item>
                            )}
                            {status.error && (
                                <Descriptions.Item label={t('Error')} span={2}><Text type="danger">{status.error}</Text></Descriptions.Item>
                            )}
                            {status.lastWadoResponseMessage && (
                                <Descriptions.Item label={t('Last WADO Response')} span={2}>{status.lastWadoResponseMessage}</Descriptions.Item>
                            )}
                        </Descriptions>
                    </div>
                ))
            )}
        </Modal>
    )
}
